/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { RosePortalAppComponent } from './app/app.component';

function bootstrapApp() {
    bootstrapApplication(RosePortalAppComponent, appConfig)
        .catch((err) => console.error(err));
}

Promise.all([
    document.fonts.load('300 1em "Material Symbols Outlined"'),
    document.fonts.load('300 1em "Material Symbols Sharp"'),
    document.fonts.load('300 1em "Material Symbols Rounded"')
]).then(() => {
    bootstrapApp();
}).catch(err => {
    bootstrapApp();
});